import { ESortingType } from "app/components/filters-bar/country-filter/CountryFilterTypes";
import { FiltersEnum } from "app/components/filters-bar/utils";
import { AccessWithoutMandatoryParamsHOC } from "app/components/React/HOCs/accessWithoutMandatoryParamsHOC";
import { withAllContextHoc } from "app/components/React/HOCs/withAllContextsHOC";
import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { DataBadgeTooltip } from "app/components/React/Tooltip/DataBadgeTooltip/DataBadgeTooltip";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { translate } from "app/filters/i18nFilter";
import { DigitalMarketingContainer } from "app/pages/digital-marketing/DigitalMarketingContainer";
import { SearchHomePage } from "app/pages/digital-marketing/SearchHomePage";
import { resolveOverrideDatePickerPresetWebsiteAnalysis } from "app/common/utils/resolveOverrideDatePickerPresetWebsiteAnalysis";
import { isProduct, isSearch, resolveChildStates } from "app/common/utils/adsTabState";
import { EGraphType } from "app/common/keyword-research/clicks-over-time-graph/graphTypes";
import { KeywordAnalysisModuleFrame } from "app/pages/keyword-research/keyword-analysis/common-components/KeywordAnalysisModuleFrame";
import { KeywordsRootLayout } from "app/pages/keyword-research/keyword-analysis/common-components/KeywordsRootLayout";
import { onRedirectAdjustGraphSwitcherParams } from "app/pages/keyword-research/keyword-analysis/common-components/onRedirectAdjustGraphSwitcherParams";
import { onRedirectKeywordGeneratorTool } from "app/pages/keyword-research/keyword-analysis/navigation/onRedirectKeywordGeneratorTool";
import { EKWGeneratorTableTabs } from "app/common/keyword-research/keyword-generator/types";
import { KeywordGeneratorModuleFrame } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/KeywordGeneratorModuleFrame";
import { KeywordGeneratorToolBasePage } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/KeywordGeneratorToolBasePage";
import { KeywordGeneratorToolSubnavFilters } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/subnav-filters/KeywordGeneratorToolSubnavFilters";
import { KeywordsOverviewPage } from "app/pages/keyword-research/keyword-analysis/pages/keywords-overview/KeywordsOverviewPage";
import { GraphSourceTypeView } from "app/common/keyword-research/keywords-overview/trendOverTimeTypes";
import { MonitorKeywordsFrame } from "app/pages/keyword-research/keyword-analysis/pages/monitor-lists/monitor-keywords-frame/MonitorKeywordsFrame";
import { MonitorKeywordsPageContainer } from "app/pages/keyword-research/keyword-analysis/pages/monitor-lists/monitor-keywords-page/MonitorKeywordsPageContainer";
import { MonitorKeywordsStartPageContainer } from "app/pages/keyword-research/keyword-analysis/pages/monitor-lists/monitor-keywords-start-page/MonitorKeywordsStartPageContainer";
import { KeywordUrlPage } from "app/pages/keyword-research/keyword-analysis/pages/pages/KeywordUrlPage";
import { SearchAdsKeywordPage } from "app/pages/keyword-research/keyword-analysis/pages/search-ads/SearchAdsKeywordPage";
import { SerpPlayersPage } from "app/pages/keyword-research/keyword-analysis/pages/serp-players/SerpPlayersPage";
import { SERPSnapshotPage } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/SERPSnapshotPage";
import { onRedirectKeywordCompetitorsPageTab } from "app/pages/keyword-research/utils/onRedirectKeywordCompetitorsPageTab";
import { onRedirectValidateSelectedPageTab } from "app/pages/keyword-research/utils/onRedirectValidateSelectedPageTab";
import { ELandingPagesTabs } from "app/common/keyword-research/landing-pages/landingPagesTypes";
import { LandingPagesV2 } from "app/pages/keyword-research/website-analysis/pages/landing-pages/LandingPagesV2";
import { RankingDistributionMain as RankingDistributionMainV2 } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/RankingDistributionMain";
import { SearchAdsWebsitePage } from "app/pages/keyword-research/website-analysis/pages/search-ads/SearchAdsWebsitePage";
import {
    EKeywordCompetitorsPageTabs,
    KeywordCompetitorsPage,
} from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPage";
import { SeoOverviewPage } from "app/pages/keyword-research/website-analysis/pages/seo-overview/SeoOverviewPage";
import { TopicsPageContainer } from "app/pages/keyword-research/website-analysis/pages/topics/TopicsPageContainer";
import { WebsiteKeywordsPage2Container } from "app/pages/keyword-research/website-analysis/pages/website-keywords/WebsiteKeywordsPage2Container";
import { CompanyResearchRoot } from "app/pages/market-research/CompanyResearchRoot";
import { QualificationSideBarContainer } from "app/pages/website-analysis/components/qualification-sidebar/QualificationSideBarContainer";
import { onEnterPageAnalysis } from "app/pages/website-analysis/config/onEnterPageAnalysis";
import { WebsiteAnalysisModuleFrame } from "app/pages/website-analysis/frame/WebsiteAnalysisModuleFrame";
import { WebsiteAnalysisPageModuleFrame } from "app/pages/website-analysis/frame/WebsiteAnalysisPageModuleFrame";
import { onRedirectAlignPresets } from "app/common/utils/onRedirectAlignPresets";
import { onRedirectRemoveCompareMode } from "app/pages/website-analysis/traffic-sources/search/navigation/onRedirectRemoveCompareMode";
import { onRedirectUpdateInlineQueryBar } from "app/pages/website-analysis/traffic-sources/search/navigation/onRedirectUpdateInlineQueryBar";
import { filterConsistencyParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { onRedirectAliasMonitorKeywordsParam } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectAliasMonitorKeywordsParam";
import { onRedirectKeywordAnalysis } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectKeywordAnalysis";
import { onRedirectQueryFilter } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectQueryFilter";
import { onRedirectRankingDistribution } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectRankingDistribution";
import { onRedirectKeywordsSERPPages } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectSERPPages";
import { onRedirectSerpSnapshot } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectSerpSnapshot";
import { onRedirectDisplayPages } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectDisplayPages";
import { onRedirectSERPPages } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectSERPPages";
import { onRedirectWebsiteAnalysis } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsiteAnalysis";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { BasicDurations } from "app/services/DurationService";
import { keywordGroupsTransforms } from "app/services/keyword-groups";
import type { ISerializable } from "app/services/solutions2Services/HomepageDataFetchers/utils";
import { SwTrack } from "app/services/SwTrack";
import { markPageViewIntentionallySkipped } from "app/services/track/pageViewTrackSignal";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { EKeywordTabs, SourceType } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { resolvers } from "../resolvers/resolvers";

const countryFilterPreferencesKey = "acquisitionChannels_countryFilter_tooltip_key";
export const trafficOverviewSearchParams: Record<string, unknown> = {
    Keywords_filters: null,
    groupedKeywords_filters: null,
    groupedKeywords_orderby: null,
    Ads_filters: null,
    IncludeOrganic: null,
    IncludePaid: null,
    IncludeBranded: null,
    multiIncludeExcludeKeywords: null,
    multiIncludeExcludeUrl: null,
    IncludeNoneBranded: null,
    IncludeNewKeywords: null,
    IncludeTrendingKeywords: null,
    IncludeQuestions: null,
    limits: null,
    BooleanSearchTerms: null,
    search: null,
    selectedDomain: null,
    orderBy: null,
    ExcludeTerms: null,
    ExcludeUrls: null,
    IncludeUrls: null,
    IncludeTerms: null,
    family: null,
    source: null,
    IncludeKeywordGroups: null,
    selectedPhrase: null,
    volumeFromValue: null,
    volumeToValue: null,
    difficultyFromValue: null,
    difficultyToValue: null,
    cpcFromValue: null,
    cpcToValue: null,
    gapFilterSelectedTab: null,
    predefinedFiler: null,
    selectedIntersection: null,
    limitsUsingAndOperator: null,
    serp: null,
    ranking: null,
    ampFilter: null,
    CustomCategory: null,
    Category: null,
    funcFlag: null,
    intentsfilter: null,
    positionTrends: null,
    metric: null,
    ExcludeKeywordGroups: null,
};

const monitorKeywordsConfig: RouterStateConfig = {
    digitalsuite_monitorkeywords_home: {
        parent: "digitalsuite_acquisition",
        url: "/monitorkeywords/home",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: MonitorKeywordsStartPageContainer,
        configId: "FindKeywordsHome",
        configIdDeps: ["KeywordAnalysis", "MobileWebSearch"],
        pageId: {
            section: "Acquisition",
            subSection: "Search/My Keyword Lists",
            subSubSection: "Monitor_Keywords_Homepage",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Keyword Lists",
            subSubSection: "Keyword Lists Homepage",
        },
        pageTitle: "digitalmarketing.monitorkeywords.homepage.title",
        skipDurationCheck: true,
        skipCountryCheck: true,
        data: {
            getCustomUrlType: () => {
                return "Acquisition Channels";
            },
        },
    },
    digitalsuite_monitorkeywords_root: {
        abstract: true,
        parent: "digitalsuite_acquisition",
        configId: "KeywordAnalysis",
        component: withAllContextHoc(MonitorKeywordsFrame),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        params: {
            mtd: "true",
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "keywordAnalysis",
        },
        pageTitle: "keywordAnalysis.page.title",
        reloadOnSearch: false,
        data: {
            getCustomUrlType: () => {
                return "Digital Marketing - Keywords";
            },
        },
    },
    digitalsuite_monitorkeywords: {
        parent: "digitalsuite_monitorkeywords_root",
        configId: "KeywordsListReport",
        url: "/findkeywords/keywordGroup/:keywordGroupId/:duration/:country/:webSource?keywordsType?activationSetId?tab",
        component: MonitorKeywordsPageContainer,
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        trackingId: {
            section: "Keyword Research",
            subSection: "Keyword Lists",
            subSubSection: "Keyword Lists Report",
        },
        pageId: {
            section: "Keyword Research",
            subSection: "Keyword Lists",
            subSubSection: "Keyword Lists Report",
        },
        configIdDeps: ["MobileWebSearch", "KeywordsGeneratorV2"],
        pageTitle: "workspaces.marketing.pageTitles.exists",
        reloadOnSearch: true,
        homeState: "digitalsuite_monitorkeywords_home",
        redirectTo: redirectPipe(onRedirectAliasMonitorKeywordsParam),
        params: {
            duration: BasicDurations.LAST_TWELVE_MONTHS,
            // The redirect hook automatically maps `keywordGroupId` to `keyword` parameter to ensure
            // seamless navigation to other keyword analysis states that expect the `keyword` param.
            // This maintains URL compatibility while enabling cross-state keyword group persistence.
            keyword: { dynamic: true },
            tab: { dynamic: true },
        },
        defaultQueryParams: {
            duration: BasicDurations.LAST_TWELVE_MONTHS,
        },
    },
};

const keywordExplorer: RouterStateConfig = {
    digitalsuite_findkeywords_keywordGeneratorTool_root: {
        abstract: true,
        parent: "digitalsuite_acquisition",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: KeywordGeneratorModuleFrame,
        configId: "KeywordAnalysis",
        params: {
            mtd: "false",
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "Acquisition Channels",
        },
        pageTitle: "keywordAnalysis.page.title",
        reloadOnSearch: false,
        data: {
            getCustomUrlType: () => {
                return "Digital Marketing - Keywords";
            },
        },
    },
    digitalsuite_findkeywords_keywordGeneratorTool: {
        parent: "digitalsuite_findkeywords_keywordGeneratorTool_root",
        configId: (_, toParams) => {
            const searchEngine = toParams?.searchEngine;
            switch (searchEngine) {
                case "google":
                    return "KeywordsGeneratorV2";
                default:
                    return "AmazonKeywordsGenerator";
            }
        },
        configIdDeps: ["MobileWeb", "MobileWebSearch", "KeywordsGenerator"],
        url:
            // eslint-disable-next-line max-len
            "/findkeywords/keyword-generator-tool/:country/:duration?searchEngine?keyword?webSource?isWWW?tab?cpcFromValue?cpcToValue?volumeFromValue?volumeToValue?difficultyFromValue?difficultyToValue?intentsfilter?selectRows?multiIncludeExcludeKeywords",
        component: AccessWithoutMandatoryParamsHOC(KeywordGeneratorToolBasePage, "keyword", "keyword"),
        bottomRightComponent: KeywordGeneratorToolSubnavFilters,
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        skipDurationCheck: true,
        redirectTo: redirectPipe(onRedirectKeywordGeneratorTool),
        stateNameForEductionBar: "findkeywords_keywordGeneratorTool",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Opportunities",
            subSubSection: "Find_Keywords/generator-google",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Keyword Explorer",
            subSubSection: "Keyword Generator",
        },
        reloadOnSearch: true,
        data: {
            getCustomUrlType: () => {
                return "Digital Marketing - Keywords";
            },
        },
        pageTitle: "find.keywords.by.industry.keyword.generator.page.title",
        pageLayoutClassName: "sw-layout-page-max-width",
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            tab: EKWGeneratorTableTabs.phraseMatch,
            duration: "28d",
            isWWW: "*",
            searchEngine: "google",
        },
        params: {
            webSource: devicesTypes.TOTAL,
            intentsfilter: { dynamic: false },
            tab: { dynamic: true, value: EKWGeneratorTableTabs.phraseMatch.toString() },
            isWWW: "*",
            searchEngine: "google",
            asc: { dynamic: true, value: false },
            sort: { dynamic: true },
            ...filterConsistencyParams,
        },
        isUSStatesSupported: true,
        homeState: "organicsearch_keywordanalysis_home",
    },
    organicsearch_keywordanalysis_root: {
        abstract: true,
        parent: "digitalsuite_acquisition_root",
        url: "/keyword",
        component: KeywordsRootLayout,
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        configId: "KeywordAnalysis",
        data: {
            menuKbItems: false,
            disableRecording: true,
            getCustomUrlType: () => {
                return "Digital Marketing - Keywords";
            },
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "Acquisition Channels",
        },
    },
    organicsearch_keywordAnalysis_search_root_2: {
        abstract: true,
        parent: "organicsearch_keywordanalysis_root",
        url: "/organic/search/:country/:duration?keyword&tab?mtd",
        component: (props) => (
            <KeywordAnalysisModuleFrame
                {...props}
                showCompactCreateListCTAButton={false}
                shouldLogErrorFallback
            />
        ),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        configId: "KeywordAnalysis",
        params: {
            mtd: "false",
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "Acquisition Channels",
        },
        pageTitle: "keywordAnalysis.page.title",
        reloadOnSearch: false,
        data: {
            pageViewTracking: function ({ toParams, toState }: any) {
                if (toParams.keyword) {
                    void SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
            getCustomUrlType: () => {
                return "keywordAnalysis";
            },
        },
    },
    organicsearch_keywordAnalysis_overview_2: {
        parent: "organicsearch_keywordAnalysis_search_root_2",
        url: "/overview_2?webSource&graphGranularity&graphDuration&graphSourceType&keywordIdeasTab",
        component: AccessWithoutMandatoryParamsHOC(withAllContextHoc(KeywordsOverviewPage), "keyword", "keyword"),
        redirectTo: redirectPipe(onRedirectKeywordAnalysis(), onRedirectAdjustGraphSwitcherParams),
        configId: "KeywordAnalysisV2Overview",
        configIdDeps: [
            "KeywordAnalysis",
            "KeywordAnalysisV2",
            "KeywordAnalysisV2Organic",
            "RankingDistribution",
            "KeywordsGeneratorV2",
        ],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/Overview",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Keyword Explorer",
            subSubSection: "Overview",
        },
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            country: "999",
            duration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
            graphSourceType: GraphSourceTypeView.TOTAL,
            keywordIdeasTab: EKWGeneratorTableTabs.relatedKeywords,
        },
        params: {
            keywordIdeasTab: EKWGeneratorTableTabs.relatedKeywords,
            graphGranularity: GranularityNames.WEEKLY,
            graphDuration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
            ...filterConsistencyParams,
        },
        dynamic: true,
        pageTitle: "keywordanalysis.2.overview.page.title",
        pageSubtitle: "keywordanalysis.2.overview.page.title.info",
        icon: "sw-icon-nav-organic",
        homeState: "organicsearch_keywordanalysis_home",
    },
    organicsearch_keywordAnalysis_2: {
        parent: "organicsearch_keywordAnalysis_search_root_2",
        url: "/keywordAnalysis_2?webSource&selectedPageTab&graphDuration&timeGranularity&graphType&category&funcFlag&domains",
        component: AccessWithoutMandatoryParamsHOC(SerpPlayersPage, "keyword", "keyword"),
        redirectTo: redirectPipe(
            onRedirectValidateSelectedPageTab(true),
            onRedirectKeywordsSERPPages(),
            onRedirectAdjustGraphSwitcherParams,
        ),
        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
            timeGranularity: GranularityNames.WEEKLY,
            graphType: EGraphType["stacked-chart"],
            graphDuration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
            country: "999",
        },
        params: {
            selectedPageTab: { dynamic: false, value: EKeywordTabs[EKeywordTabs.Total] },
            webSource: { dynamic: false },
            siteFilter: { dynamic: false },
            domains: { dynamic: false },
            keyword: { dynamic: false },
            category: { dynamic: false },
            funcFlag: { dynamic: false },
            ...filterConsistencyParams,
        },
        dynamic: true,
        stateNameForEductionBar: "competitiveanalysis_website_search_competitors",
        configId: "KeywordAnalysisV2Organic",
        configIdDeps: ["KeywordAnalysis", "KeywordAnalysisV2"],
        resetOnKeywordChange: true,
        reset: {
            category: null,
            funcFlag: null,
            domains: null,
        },
        pageId: {
            section: "Acquisition",
            subSection: "Search/Search 3.0",
            subSubSection: "Traffic 2.0",
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Keyword Explorer",
                subSubSection: `${selectedPageTab} SERP Players`,
                subSubSubSection: selectedPageTab,
            };
        },
        isUSStatesSupported: false,
        skipCountryCheck: true,
        pageTitle: "keywordanalysis.2.page.title",
        pageSubtitle: "keywordanalysis.2.page.title.tooltip",
        icon: "sw-icon-nav-organic",
        homeState: "organicsearch_keywordanalysis_home",
        durationHookV4: true,
        customData: {
            countryFilterPreferencesKey,
        },
    },
    organicsearch_keywordAnalysis_search_root: {
        abstract: true,
        parent: "organicsearch_keywordanalysis_root",
        url: "/organic/search/:country/:duration?keyword&tab?mtd",
        component: KeywordAnalysisModuleFrame,
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        configId: "KeywordAnalysis",
        params: {
            mtd: "false",
            keyword: { dynamic: false },
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Site Explorer",
            subSubSection: "Search Ads",
        },
        pageTitle: "keywordAnalysis.page.title",
        reloadOnSearch: false,
        data: {
            pageViewTracking: function ({ toParams, toState }: any) {
                if (toParams.keyword) {
                    void SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
            getCustomUrlType: () => {
                return "keywordAnalysis";
            },
        },
    },
    organicsearch_trafficAnalysis_2: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: "/trafficAnalysis_2?webSource&selectedPageTab&graphDuration&timeGranularity&graphType&category&funcFlag&domains",
        component: AccessWithoutMandatoryParamsHOC(KeywordUrlPage, "keyword", "keyword"),
        redirectTo: redirectPipe(
            onRedirectValidateSelectedPageTab(true),
            onRedirectKeywordsSERPPages(),
            onRedirectAdjustGraphSwitcherParams,
        ),

        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
            country: "999",
            graphDuration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
            timeGranularity: GranularityNames.WEEKLY,
            graphType: EGraphType["stacked-chart"],
        },
        params: {
            webSource: { dynamic: false },
            siteFilter: { dynamic: false },
            domains: { dynamic: false },
            keyword: { dynamic: false },
            category: { dynamic: false },
            funcFlag: { dynamic: false },
            ...filterConsistencyParams,
        },
        dynamic: true,
        stateNameForEductionBar: "digitalsuite_kwAnalysis_page3",
        configId: "KeywordAnalysisV2Organic",
        configIdDeps: ["KeywordAnalysis", "KeywordAnalysisV2"],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Search 3.0",
            subSubSection: "Traffic 2.0",
        },
        resetOnKeywordChange: true,
        reset: {
            category: null,
            funcFlag: null,
            domains: null,
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Keyword Explorer",
                subSubSection: `${selectedPageTab} Pages`,
                subSubSubSection: selectedPageTab,
            };
        },
        isUSStatesSupported: false,
        skipCountryCheck: true,
        pageTitle: "trafficanalysis.2.page.title",
        pageSubtitle: "trafficanalysis.2.page.title.tooltip",
        icon: "sw-icon-nav-organic",
        homeState: "organicsearch_keywordanalysis_home",
        customData: {
            countryFilterPreferencesKey,
        },
    },

    paidsearch_keywordAnalysis_serp_ads: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: "/ads?webSource&type&selectedCategory&orderBy&search&selectedPageTab&multiIncludeExcludeTitle&multiIncludeExcludeUrl&domains",
        stateNameForEductionBar: "keywordAnalysis_ads",
        component: AccessWithoutMandatoryParamsHOC(SearchAdsKeywordPage, "keyword"),
        resolve: [resolvers.siteInfo],
        redirectTo: redirectPipe(onRedirectDisplayPages(), onRedirectQueryFilter),
        configId: "KeywordAnalysisV2Organic",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/topads",
        },

        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EAdsTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Keyword Explorer",
                subSubSection: `Search Ads ${selectedPageTab} `,
                subSubSubSection: "Search Ads",
            };
        },
        reloadOnSearch: true,
        isUSStatesSupported: true,
        params: {
            webSource: devicesTypes.DESKTOP,
            country: "999",
            duration: BasicDurations.LAST_THREE_MONTHS,
            selectedPageTab: EAdsTabs[EAdsTabs.Text],
            domains: { dynamic: false },

            ...filterConsistencyParams,
        },
        resetOnKeywordChange: true,
        reset: {
            domains: null,
        },
        defaultQueryParams: {
            selectedPageTab: EAdsTabs[EAdsTabs.Text],
        },
        pageTitle: "digitalsuite.keywordAnalysis.ads.unify.page.title",
        pageSubtitle: "KeywordAnalysis.ads.title.tooltip",
        pageLayoutClassName: "sw-layout-page-max-width",
        homeState: "paidsearch_keywordanalysis_home",
    },
    digitalsuite_keywordAnalysis_serpSnapshot: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: `/serpsnapshot?webSource?${Object.keys(trafficOverviewSearchParams).join(`?`)}`,
        component: AccessWithoutMandatoryParamsHOC(SERPSnapshotPage, "keyword", "keyword"),
        stateNameForEductionBar: "keywordAnalysis_serpSnapshot",
        redirectTo: redirectPipe(onRedirectKeywordsSERPPages(), onRedirectSerpSnapshot),
        isUSStatesSupported: false,
        skipCountryCheck: true,
        configId: "SerpSnapshot",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/Serp Snapshot",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Keyword Explorer",
            subSubSection: "SERP Snapshot",
        },
        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            country: 999,
            duration: "3m",
        },
        params: {
            ...filterConsistencyParams,
        },
        reloadOnSearch: true,
        pageTitle: "keyword.analysis.serp.snapshot.page.title",
        pageSubtitle: "keyword.analysis.serp.snapshot.page.title.info",
        icon: "sw-icon-nav-organic",
        homeState: "organicsearch_keywordanalysis_home",
        customData: {
            isCountryFilterAllowData: (keyword: any) => {
                return !keywordGroupsTransforms.isKeywordGroup(keyword);
            },
            get countryFilterSortingText() {
                return `${translate("country.filter.serp.page.sorting.by.search.volume")}`;
            },
            countryFilterInitialSortingType: (keyword: any) => {
                return keywordGroupsTransforms.isKeywordGroup(keyword) ? ESortingType.NAME : ESortingType.DATA;
            },
            dataBadgeTooltip: () => {
                return <DataBadgeTooltip>keywords.serp.banner</DataBadgeTooltip>;
            },
            countryFilterPreferencesKey,
            allowHoverDataBadgeTooltip: true,
        },
    },
};

const siteExplorer: RouterStateConfig = {
    organicsearch_websiteanalysis: {
        parent: "sw",
        abstract: true,
        packageName: "digitalsuite",
        component: DigitalMarketingContainer,
        configId: "WebsiteanalysisAnalysisOverviewHome",
        secondaryBarType: "DigitalSuiteAcquisition",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        isSecondaryBarOpen: true,
        navBarContainerClassName: "accordion-side-bar",
    },
    organicsearch_websiteanalysis_home: {
        parent: "organicsearch_websiteanalysis",
        url: "/organicsearch/websiteanalysis/home",
        component: () => (
            <SearchHomePage filterRecentsBy={["organicsearch_website", "digitalsuite_pageAnalysis_root"]} />
        ),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        configId: "DigitalSuiteAcquisition",
        configIdDeps: ["WorldwideOverviewPage"],
        clearSearch: true, // required for clean selected entities on tracking
        secondaryBarType: "DigitalSuiteAcquisition",
        pageId: {
            section: "Acquisition",
            subSection: "Search/home",
            subSubSection: "Analyze Websites",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Homepage",
        },
        pageTitle: "search.websiteanalysis.homepage.title",
    },
    "organicsearch_websiteanalysis-root": {
        abstract: true,
        parent: "organicsearch_websiteanalysis",
        secondaryBarType: "DigitalSuiteAcquisition",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: () => <CompanyResearchRoot />,
    },
    organicsearch_website: {
        parent: "organicsearch_websiteanalysis-root",
        url: "/digitalsuite/acquisition/websiteanalysis",
        component: withAllContextHoc((props: FixmeType) => (
            <WebsiteAnalysisModuleFrame
                {...props}
                filterRecentsBy={["organicsearch_website", "digitalsuite_pageAnalysis_root"]}
            />
        )),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        abstract: true,
        configId: "WebAnalysis",
        data: {
            menuId: "websites",
            filtersConfig: {
                duration: FiltersEnum.ENABLED,
                country: FiltersEnum.ENABLED,
                webSource: FiltersEnum.ENABLED,
            },
            pageViewTracking: function ({ toParams, toState }: any) {
                if (toParams.key) {
                    void SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
            getCustomUrlType: () => {
                return "website";
            },
        },
    },
    digitalsuite_pageAnalysis_root: {
        abstract: true,
        parent: "organicsearch_websiteanalysis",
        url: "/organicsearch/pageAnalysis",
        component: (props) => (
            <WebsiteAnalysisPageModuleFrame
                {...props}
                filterRecentsBy={["digitalsuite_pageAnalysis_root", "organicsearch_website"] as any}
            />
        ),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        secondaryBarType: "DigitalSuiteAcquisition",
        data: {
            getCustomUrlType: () => {
                return "website";
            },
        },
    },
    paidsearch_website: {
        abstract: true,
        parent: "organicsearch_websiteanalysis",
        url: "/digitalsuite/acquisition/websiteanalysis",
        component: withAllContextHoc(WebsiteAnalysisModuleFrame),
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        configId: "WebAnalysis",
        data: {
            menuId: "websites",
            filtersConfig: {
                duration: FiltersEnum.ENABLED,
                country: FiltersEnum.ENABLED,
                webSource: FiltersEnum.ENABLED,
            },
            pageViewTracking: function ({ toParams, toState }: any) {
                if (toParams.key) {
                    void SwTrack.trackPageView(toState, toParams);
                } else {
                    markPageViewIntentionallySkipped();
                }
            },
            getCustomUrlType: () => {
                return "website";
            },
        },
    },
    organicsearch_websites_v2_traffic_keywords: {
        parent: "digitalsuite_pageAnalysis_root",
        url: `/website-keyword-v2/:isWWW/:country/:duration?key&pageFilter&webSource&IncludeBranded&IncludeNoneBranded&multiIncludeExcludeKeywords&multiIncludeExcludeUrl&volumeFromValue&volumeToValue&cpcFromValue&cpcToValue&Change&source&family&trafficPreset&selectedPageTab&comparedDuration`,
        configId: "WebsiteKeywordsV2",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: AccessWithoutMandatoryParamsHOC(WebsiteKeywordsPage2Container, "key"),
        stateNameForEductionBar: "digitalsuite_websiteKWs_page3",
        redirectTo: redirectPipe(
            onRedirectValidateSelectedPageTab(false),
            onRedirectSERPPages(),
            onRedirectAlignPresets,
        ),
        onEnter: onEnterPageAnalysis,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Search 3.0",
            subSubSection: "keyword",
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Site Explorer",
                subSubSection: `${selectedPageTab} Keywords`,
                subSubSubSection: selectedPageTab,
            };
        },
        defaultQueryParams: {
            isWWW: "*",
            webSource: devicesTypes.TOTAL,
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
        },
        params: {
            isWWW: "*",
            country: "999",
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
            comparedDuration: "",
            ...filterConsistencyParams,
        },
        icon: "sw-icon-search",
        pageTitle: "website.keywords.2.0.page.title",
        pageSubtitle: "competitors.search.keywords.page.title.info",
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        configIdDeps: ["KeywordAnalysis", "MobileWeb"],
        homeState: "organicsearch_websiteanalysis_home",
        pageLayoutClassName: "sw-layout-page-max-width",
        reset: trafficOverviewSearchParams,
        resetOnMainSiteChange: true,
        dynamic: false,
        durationHookV4: true,
        compareButtonText: "website.keywords.2.0.compare.button",
        periodOverPeriodEnabled: true,
        get overrideDatepickerPreset() {
            return resolveOverrideDatePickerPresetWebsiteAnalysis();
        },
        periodOverPeriodMaxAllowedDuration: BasicDurations.LAST_SIX_MONTHS,
    },

    organicsearch_seo_overview: {
        parent: "digitalsuite_pageAnalysis_root",
        url:
            "/seo-overview/:isWWW/:country/:duration?key&pageFilter&webSource&IncludeBranded" +
            "&IncludeNoneBranded&multiIncludeExcludeKeywords&multiIncludeExcludeWebsites&volumeFromValue" +
            "&volumeToValue&cpcFromValue&cpcToValue&TopOrganicPagesFilter&TopOrganicKeywordsFilter&source&" +
            "family&trafficPreset&selectedPageTab&Change&competitorsFilter&vennDiagramSourceType",
        configId: "SEOOverview",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: AccessWithoutMandatoryParamsHOC(SeoOverviewPage, "key"),
        redirectTo: redirectPipe(onRedirectRemoveCompareMode, onRedirectSERPPages(), onRedirectUpdateInlineQueryBar),
        onEnter: onEnterPageAnalysis,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Keyword Research",
            subSection: "Search/Search 3.0",
            subSubSection: "Seo Overview",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Site Explorer",
            subSubSection: "SEO Overview",
        },
        defaultQueryParams: {
            isWWW: "*",
            webSource: devicesTypes.TOTAL,
            vennDiagramSourceType: SourceType.TOTAL,
        },
        params: {
            isWWW: "*",
            country: "999",
            webSource: devicesTypes.TOTAL,
            ...filterConsistencyParams,
            competitorsFilter: { dynamic: true },
            vennDiagramSourceType: { dynamic: true, value: SourceType.TOTAL },
        },
        icon: "sw-icon-search",
        pageTitle: "website.seo.overview.page.title",
        pageSubtitle: "website.seo.overview.page.title.info",
        homeState: "organicsearch_websiteanalysis_home",
        reset: { ...trafficOverviewSearchParams, competitorsFilter: null },
        durationHookV4: true,
        hideCompareButton: true,
    },

    search_website_topics: {
        parent: "organicsearch_website",
        url: `/topics/:isWWW/:country/:duration?key&pageFilter&webSource&multiIncludeExcludeTopic&trend&selectedPageTab`,
        configId: "WebsiteTopics",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        component: AccessWithoutMandatoryParamsHOC(TopicsPageContainer, "key"),
        redirectTo: redirectPipe(
            onRedirectValidateSelectedPageTab(false),
            onRedirectRemoveCompareMode,
            onRedirectSERPPages(),
            onRedirectAlignPresets,
        ),
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Keyword Research",
            subSection: "Search/Search 3.0",
            subSubSection: "Topics",
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Site Explorer",
                subSubSection: `${selectedPageTab} Topics`,
                subSubSubSection: selectedPageTab,
            };
        },
        defaultQueryParams: {
            isWWW: "*",
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
            webSource: devicesTypes.TOTAL,
        },
        params: {
            isWWW: "*",
            country: "999",
            selectedPageTab: EKeywordTabs[EKeywordTabs.Total],
            ...filterConsistencyParams,
        },
        icon: "sw-icon-search",
        pageTitle: "website.topics.page.title",
        pageSubtitle: "website.topics.page.title.info",
        homeState: "organicsearch_websiteanalysis_home",
        hideCompareButton: true,
        viewConfig: {
            recentsDedupeFunction: (recent: ISerializable) => {
                return recent.data?.mainItem?.toLowerCase();
            },
        },
    },

    organicsearch_website_landingpages_v2: {
        parent: "digitalsuite_pageAnalysis_root",
        // eslint-disable-next-line max-len
        url: "/landing-pages-v2/:isWWW/:country/:duration?key&pageFilter&webSource&selectedDomain&Change&serp&multiIncludeExcludeWebsites&multiIncludeExcludeKeywords&selectedPageTab",
        component: AccessWithoutMandatoryParamsHOC(LandingPagesV2, "key"),
        redirectTo: redirectPipe(onRedirectValidateSelectedPageTab(false, SourceType.ORGANIC), onRedirectSERPPages()),
        onEnter: onEnterPageAnalysis,
        stateNameForEductionBar: "digitalsuite_landingPages_page3",
        configId: "OrganicLandingPagesV2",
        configIdDeps: ["KeywordAnalysisMobileTraffic2"],
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Search 3.0",
            subSubSection: "LandingPages2.0",
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Site Explorer",
                subSubSection: `${selectedPageTab} Landing Pages`,
                subSubSubSection: selectedPageTab,
            };
        },
        pageTitle: "digitalsuite.landing.pages.page.title",
        pageSubtitle: "digitalsuite.landing.pages.page.subtitle",
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            selectedPageTab: ELandingPagesTabs[ELandingPagesTabs.Organic],
        },
        params: {
            isWWW: "*",
            country: "999",
            selectedPageTab: ELandingPagesTabs[ELandingPagesTabs.Organic],
            ...filterConsistencyParams,
        },
        durationHookV4: true,
        pageLayoutClassName: "sw-layout-page-max-width",
        homeState: "organicsearch_websiteanalysis_home",
        dynamic: false,
    },
    "organicsearch_websites-competitorsKeywords": {
        parent: "organicsearch_website",
        url:
            // eslint-disable-next-line max-len
            "/website-competitors/:isWWW/:country/:duration?key&webSource&orderby?selectedSite?websiteType?organicSearchType?risingCompetitors?newCompetitors?category?search?selectedPageTab",
        reset: {
            orderby: null,
            selectedSite: null,
            websiteType: null,
            organicSearchType: null,
            risingCompetitors: null,
            newCompetitors: null,
            category: null,
            search: null,
        } as Record<string, unknown>,
        component: AccessWithoutMandatoryParamsHOC(KeywordCompetitorsPage, "key"),
        qualificationSideBarComponent: QualificationSideBarContainer,
        stateNameForEductionBar: "competitiveanalysis_website_search_organic_competitors",
        redirectTo: redirectPipe(onRedirectKeywordCompetitorsPageTab, onRedirectWebsiteAnalysis()),
        resolve: [resolvers.siteInfo],
        configId: "SearchCompetitors",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Organic Website Analysis",
            subSubSection: "competitors",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Site Explorer",
            subSubSection: "Competitors",
        },
        icon: "sw-icon-search-competitors",
        pageTitle: "analysis.search.organic.competitors.title",
        pageSubtitle: "analysis.search.organic.competitors.title.tooltip",
        searchParams: ["selectedSite"],
        isVirtualSupported: false,
        isUSStatesSupported: true,
        homeState: "organicsearch_websiteanalysis_home",
        params: {
            duration: "3m",
            isWWW: "*",
            country: "999",
            webSource: devicesTypes.TOTAL,
            selectedPageTab: EKeywordCompetitorsPageTabs[EKeywordCompetitorsPageTabs.Organic],
            ...filterConsistencyParams,
        },
        defaultQueryParams: {
            selectedPageTab: EKeywordCompetitorsPageTabs[EKeywordCompetitorsPageTabs.Organic],
        },
        data: {
            filtersConfig: {
                duration: FiltersEnum.DISABLED,
                webSource: FiltersEnum.DISABLED,
            },
        },
    },

    organicsearch_website_search_ranking_distribution_v2: {
        parent: "digitalsuite_pageAnalysis_root",
        url: `/ranking-distribution-v2/:isWWW/:country/:duration?key&webSource?${Object.keys(
            trafficOverviewSearchParams,
        ).join(`?`)}&pageFilter`,
        configId: "RankingDistributionV2",
        secondaryBarType3: SecondarySideBarType3.KeywordResearch,
        redirectTo: redirectPipe(onRedirectRankingDistribution, onRedirectQueryFilter),
        onEnter: onEnterPageAnalysis,
        resolve: [resolvers.siteInfo],
        component: AccessWithoutMandatoryParamsHOC(RankingDistributionMainV2, "key"),
        stateNameForEductionBar: "digitalsuite_websiteKWs_page3",
        skipFilterConsistency: false,
        // redirectTo: redirectPipe(onRedirectRankingDistribution),
        isUSStatesSupported: false,
        skipCountryCheck: true,
        pageId: {
            section: "website",
            subSection: "traffic",
            subSubSection: "search-ranknig-distribution",
        },
        trackingId: {
            section: "Keyword Research",
            subSection: "Site Explorer",
            subSubSection: "Ranking Distribution",
        },
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            isWWW: "*",
            duration: "3m",
        },
        params: {
            isWWW: "*",
            duration: "3m",
            dynamic: false,
        },
        icon: "sw-icon-search",
        hidePageTitle: true,
        searchParams: ["webSource"],
        pageTitle: "competitors.search.ranking.distribution.page.title",
        pageSubtitle: "competitors.search.ranking.distribution.page.subtitle",
        data: {
            trackPageViewOnSearchUpdate: false,
            // SIM-35845
            disableNoTouchForCountryFilter: true,
        },
        configIdDeps: ["KeywordAnalysis", "MobileWeb"],
        homeState: "organicsearch_websiteanalysis_home",
        reset: trafficOverviewSearchParams,
        // decides whether to reset when replacing the main site
        resetOnMainSiteChange: true,
        dynamic: false,
        durationHookV4: true,
        customData: {
            isCountryFilterAllowData: true,
            countryFilterInitialSortingType: ESortingType.DATA,
            get countryFilterSortingText() {
                return `${translate("country.filter.sorting.by.keywords")}`;
            },
            countryFilterPreferencesKey,
        },
    },
    paidsearch_website_ads: {
        parent: "digitalsuite_pageAnalysis_root",
        url: `/website_ads/:isWWW/:country/:duration?pageFilter?key&webSource?${Object.keys(
            trafficOverviewSearchParams,
        ).join(`?`)}&selectedPageTab&selectedSite`,
        stateNameForEductionBar: "keywordAnalysis_ads",
        component: AccessWithoutMandatoryParamsHOC(SearchAdsWebsitePage, "key"),
        resolve: [resolvers.siteInfo],
        redirectTo: redirectPipe(onRedirectDisplayPages(), onRedirectQueryFilter),
        onEnter: onEnterPageAnalysis,
        pageId: {
            section: "Acquisition",
            subSection: "Search/Paid Website Analysis",
            subSubSection: "Competitive Analysis/ads",
        },
        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EAdsTabs = toParams?.selectedPageTab;
            return {
                section: "Keyword Research",
                subSection: "Site Explorer",
                subSubSection: `Search Ads ${selectedPageTab} `,
                subSubSubSection: "Search Ads",
            };
        },
        defaultQueryParams: {
            webSource: "Desktop",
            isWWW: isSearch() ?? "*",
            selectedPageTab: EAdsTabs[EAdsTabs.Text],
        },
        icon: "sw-icon-search",
        hidePageTitle: true,
        searchParams: ["webSource"],
        pageTitle: "competitors.search.ads.page.title",
        pageSubtitle: "competitors.search.ads.page.title.info",
        isUSStatesSupported: false,
        pageLayoutClassName: "sw-layout-page-max-width",
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        configId: "KeywordAnalysisV2Organic",
        configIdDeps: ["MobileWebSearch"],
        get childStates() {
            return ({ webSource }: FixmeType) => resolveChildStates(webSource);
        },
        reset: isProduct() ?? trafficOverviewSearchParams,
        homeState: "search_websiteanalysis_home",
        params: {
            selectedPageTab: { dynamic: true },
            isWWW: "*",
            country: "999",
            ...filterConsistencyParams,
        },
    },
};

export const keywordResearchConfig: RouterStateConfig = {
    ...monitorKeywordsConfig,
    ...keywordExplorer,
    ...siteExplorer,
};
